


































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
import TheFormCategories from '@/components/categories/TheFormCategories.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
// Importing functions
import {putCategory} from '@/ts/categories/put-category';
import {getCategory} from '@/ts/categories/get-category';
import {validateCategory} from '@/ts/categories/validate-category';

export default {
    name: 'PageCategoriesUpdate',
    components: {
        LayoutApp,
        BaseCard,
        BaseAlertList,
        TheFormCategories,
        BaseLoadingAnimation,
    },
    props: {},
    data() {
        return {
            data: Object(),
            items: Array(),
            errors: Array(),
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateCategory(this.errors, this.data);

            if (this.errors.length === 0) {
                this.$store.dispatch('setLoadingOn');

                putCategory(this.data, this.$route.params.id, this.$route.params.category_id).then(() => {
                    this.$router.push({ name: 'categories', params: { id: this.$route.params.id} });
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Категории',
            to: { name: 'categories', params: { id: this.$route.params.id} },
        }, {
            text: 'Редактиране',
        }];
        // Initializing the user data object
        this.data = {
            name: '',
            description: '',
            is_active: '1',
        };
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getCategory(this.$route.params.id, this.data, this.$route.params.category_id).then((response) => {
            this.data = response;
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
